<template>
    <div
        class="addtext_color addtext_color_box_addtext_sec color-last"
        style="margin-right: 2px"
    >
        <div :class="showLabel === false ? '' : 'form-group color-flex'">
            <div>
                <label v-show="showLabel !== false">Colors</label>
                <span class="highlight"></span>
            </div>
            <div>
                <div class="input-group color-picker flex" style="width: 100%">
                    <span class="input-group-addon color-picker-container">
                        <span
                            v-tooltip="`${value}`"
                            class="current-color"
                            :style="colorBox()"
                            @click="togglePicker()"
                        ></span>
                       <svg class="arrow_icon" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 11L6 6L1 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ColorBox",
    props: ["value", "showLabel", "colorListValue"],

    data: () => {
        return {};
    },
    methods: {
        colorBox() {
            let border = this.noInput ? "4px" : "0px 4px 4px 0px";
            return `background-color: ${this.value};
                    border-radius: ${border}
                    `;
        },
        togglePicker() {
            this.$emit("set-value", this.value);
        },
        setValue(e) {
            this.$emit("set-value", e);
        }
    }
};
</script>

<style></style>
